module.exports = __webpack_public_path__ + "img/product1.169d402d.png";